/**
 * Shown when VITE_CONVEX_URL is not set. Guides user to run Convex and set env.
 */
export function ConvexSetupRequired() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center">
      <div className="max-w-md space-y-6">
        <div className="flex justify-center">
          <img
            src="/eventtools-logo.svg"
            alt="Event.Tools"
            className="h-10 w-auto opacity-90"
          />
        </div>
        <h1 className="text-xl font-semibold text-foreground">
          Convex not configured
        </h1>
        <p className="text-muted-foreground text-sm">
          The web app needs a Convex deployment URL to run. Set it up once, then
          add <code className="rounded bg-muted px-1.5 py-0.5 text-foreground">VITE_CONVEX_URL</code> in{' '}
          <code className="rounded bg-muted px-1.5 py-0.5 text-foreground">apps/web/.env.local</code>.
        </p>
        <ol className="text-left text-sm text-muted-foreground space-y-2 list-decimal list-inside">
          <li>
            From repo root: <code className="rounded bg-muted px-1.5 py-0.5">cd apps/web</code>
          </li>
          <li>
            Run <code className="rounded bg-muted px-1.5 py-0.5">npx convex dev</code> (create/link project if prompted)
          </li>
          <li>
            Copy the deployment URL and add to <code className="rounded bg-muted px-1.5 py-0.5">.env.local</code> as{' '}
            <code className="rounded bg-muted px-1.5 py-0.5">VITE_CONVEX_URL=&lt;url&gt;</code>
          </li>
          <li>Restart the dev server</li>
        </ol>
        <p className="text-xs text-muted-foreground">
          See <strong>CLOUD_SETUP.md</strong> in the repo root for full setup and verification.
        </p>
      </div>
    </div>
  );
}
